function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F8F9FF",
  d: "M5 45.989h20c2.75 0 5-2.235 5-4.965 0-2.733-2.25-4.967-5-4.967H5c-2.75 0-5-2.235-5-4.965s2.25-4.965 5-4.965h100c2.75 0 5 2.234 5 4.965 0 2.73-2.25 4.965-5 4.965H85c-2.749 0-5 2.234-5 4.967 0 2.73 2.251 4.965 5 4.965h27.5c2.75 0 5 2.234 5 4.965 0 2.73-2.25 4.967-5 4.967H91.25c-2.062 0-3.75 1.675-3.75 3.724 0 2.047 1.688 3.724 3.75 3.724H115c2.75 0 5 2.235 5 4.965s-2.25 4.965-5 4.965H10c-2.749 0-5-2.234-5-4.965 0-2.73 2.251-4.965 5-4.965h23.75c2.064 0 3.75-1.677 3.75-3.724 0-2.05-1.686-3.724-3.75-3.724H5c-2.75 0-5-2.237-5-4.967 0-2.73 2.25-4.965 5-4.965"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FBFCFD",
  d: "M89.891 90.433a6.485 6.485 0 0 0 9.174 0 6.486 6.486 0 0 0 0-9.175L85.313 67.506l-9.175 9.175L89.89 90.433zM66.207 67.96l8.845 8.65 9.362-9.153L76 59.23a34.113 34.113 0 0 1-9.794 8.73"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EDF0FE",
  d: "M76.138 76.413l13.474 14.003a6.157 6.157 0 0 0 7.216 1.27L79.134 73.3l-2.996 3.114z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EDF0FE",
  d: "M70.818 65.85c-1.206.944-2.454 1.84-3.784 2.629l9.176 8.958 3.238-3.16-8.63-8.426z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#DAE1FD",
  strokeWidth: 0.75,
  d: "M89.891 90.433a6.485 6.485 0 0 0 9.174 0 6.486 6.486 0 0 0 0-9.175L85.313 67.506l-9.175 9.175L89.89 90.433zM66.207 67.96l8.845 8.65 9.362-9.153L76 59.23a34.113 34.113 0 0 1-9.794 8.73z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M81.931 41.023c0 18.282-14.82 33.104-33.103 33.104-18.284 0-33.104-14.822-33.104-33.104 0-18.283 14.82-33.103 33.104-33.103 18.283 0 33.103 14.82 33.103 33.103"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#DAE1FD",
  strokeWidth: 0.75,
  d: "M81.931 41.023c0 18.282-14.82 33.104-33.103 33.104-18.284 0-33.104-14.822-33.104-33.104 0-18.283 14.82-33.103 33.104-33.103 18.283 0 33.103 14.82 33.103 33.103z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EDF0FE",
  d: "M76.966 41.023c0 15.082-12.227 27.31-27.31 27.31-15.085 0-27.311-12.228-27.311-27.31 0-15.084 12.226-27.31 27.31-27.31 15.084 0 27.31 12.226 27.31 27.31"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#DAE1FD",
  strokeWidth: 0.75,
  d: "M76.966 41.023c0 15.082-12.227 27.31-27.31 27.31-15.085 0-27.311-12.228-27.311-27.31 0-15.084 12.226-27.31 27.31-27.31 15.084 0 27.31 12.226 27.31 27.31z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B5B7BA",
  d: "M46.77 23.145L34.327 35.588"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FBFCFD",
  strokeLinecap: "round",
  strokeWidth: 0.75,
  d: "M46.77 23.145L34.327 35.588"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B5B7BA",
  d: "M54.596 25.597L34.313 45.783"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FBFCFD",
  strokeLinecap: "round",
  strokeWidth: 0.75,
  d: "M54.596 25.597L34.313 45.783"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FBFCFD",
  d: "M32.793 40.04c0 .826-.672 1.5-1.5 1.5s-1.5-.674-1.5-1.5a1.5 1.5 0 0 1 3 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E3E9FD",
  d: "M112.241 87.213a1.5 1.5 0 1 1-3-.001 1.5 1.5 0 0 1 3 .001"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#E3E9FD",
  strokeWidth: 0.75,
  d: "M18.207 99.368a2.898 2.898 0 0 1-5.793 0 2.898 2.898 0 0 1 5.793 0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#E3E9FD",
  strokeLinecap: "round",
  strokeWidth: 0.75,
  d: "M25.655 82.403h5.793m-2.482 2.482v-5.793M85.241 14.54h5.793m-2.482 2.483V11.23"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E3E9FD",
  d: "M101.793 2.954a2.48 2.48 0 0 1-2.483 2.483 2.48 2.48 0 0 1-2.482-2.483A2.48 2.48 0 0 1 99.31.472a2.48 2.48 0 0 1 2.483 2.482"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#E3E9FD",
  strokeLinejoin: "round",
  strokeWidth: 0.5,
  d: "M15.724 6.937v1.5-3zm0 5.793v1.5-3zm-1.81-3.983h1.5-3zm5.793 0h1.5-3zm-.827-1.81l-1.5 1.5 1.5-1.5 1.5-1.5zm-4.139 4.966l-1.5 1.5 1.5-1.5 1.5-1.5zm0-4.966l1.5 1.5-1.5-1.5-1.5-1.5zm4.139 4.966l1.5 1.5-1.5-1.5-1.5-1.5zm54.775 84.413v1.5-3zm0 5.794v1.5-3zm-2.638-3.983h1.5-3zm7.449 0h1.5-3zm-1.656-.983l-1.5 1.5 1.5-1.5 1.5-1.5zm-4.965 4.966l-1.5 1.5 1.5-1.5 1.5-1.5zm0-4.966l1.5 1.5-1.5-1.5-1.5-1.5zm4.965 4.966l1.5 1.5-1.5-1.5-1.5-1.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0-9h120v120H0z"
}));

var SvgNoResult = function SvgNoResult(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 104,
    viewBox: "0 0 120 104",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoResult, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/noResult.a66c317b.svg";
export { ForwardRef as ReactComponent };